import axios from "axios";
import $ from "jquery";
var colorArr = [
    '#e60ff9',
    '#0096ff',
    '#fcff00',
    '#ff9600',
    '#0006ff',
    '#6600ff',
    '#02ffe4',
    '#35cbf1',
    '#f1d035',
    '#ffffff'],
    strArr = [];

window.laz = [];
let pcXX = window.innerHeight / 1480;
export function getMessage () {
    axios.post("https://bulletchat.event1.cn/dpm/nissanChat").then((res) => {
        for (let i = 0; i < res.data.length; i++) {
            window.laz.push(
                res.data[i].split("||")[0] +
                "||" +
                res.data[i].split("||")[1] +
                "||" +
                res.data[i].split("||")[2]
            );
        }
        init();
    }).catch((err) => { console.log("网络延时，请重试", err); })
}
var id = 0,
    op = 0,
    index = 0,
    renderLoop;
let $dmtiv;

document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
        clearInterval(renderLoop);
    } else {
        init();
    }
});
export function initClose () {
    clearInterval(renderLoop);
}

function init () {
    clearInterval(renderLoop);
    let num = -1;
    $dmtiv = [".dmt3", ".dmt1", ".dmt4", ".dmt2", ".dmt5"];
    let time = setInterval(() => {
        num++;
        if (num == $dmtiv.length - 1) {
            clearInterval(time)
        }
        const el = document.querySelector($dmtiv[num]);
        if (laz.length === 0) {
        } else {
            id++;
            index++;
            auto(el, op, id);
            op++;
            if (op > laz.length - 1) {
                op = 0;
            }
            if (num == $dmtiv.length - 1) {

                renderLoop = setInterval(function () {
                    inint();
                }, 1500);
            }
        }
    }, 1000)
}

function auto (ac, opc, $id) {
    if (ac) {
        if (laz[opc] == "undefined" && op < laz.length - 2) {
            strArr = laz[opc + 1].split("||");
        } else {
            try {
                strArr = laz[opc].split("||");
            } catch (e) {
                strArr = laz[1].split("||");
            }
        }
        var $value = strArr[0];
        var num = parseInt(colorArr.length * Math.random());

        let vp = document.createElement("p");
        vp.id = "cl" + $id;
        vp.setAttribute('data-cid', strArr[1]);
        let vspan = document.createElement("span");
        let vimg = new Image();
        vspan.innerText = $value;
        vimg.src = strArr[2];
        vp.appendChild(vimg);
        vp.appendChild(vspan);
        ac.appendChild(vp);
        var lastp = document.getElementById("cl" + $id);
        lastp.style.color = colorArr[parseInt(colorArr.length * Math.random())];
        lastp.animate(
            [{ transform: "translateX(0)" }, { transform: "translateX(-2300px)" }],
            { duration: 20000 }
        );
    }

}

function inint () {
    let isMobile = /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i;
    if (isMobile.test(navigator.userAgent.toLowerCase())) {
        pcXX = 1;
    }

    let innerW = $(".dmt").width() * pcXX;
    $(".dmt").each(function () {
        let rdfNum = 0;
        if (!isMobile.test(navigator.userAgent.toLowerCase())) {
            rdfNum = -70;
        } else {
            rdfNum = RDF(40, 60);
        }

        if ($(this).children().length > 0) {
            let $p1 = $(this)
                .children("p")
                .last();
            let X1 = $p1.position().left,
                thisW1 = $p1.width();
            if (innerW - X1 > thisW1 + rdfNum) {
                id++;
                auto(this, op, id);
                op++;
                if (op > laz.length - 1) {
                    op = 0;
                }
            }
        } else {
            id++;
            let $dmtitem = this;
            auto($dmtitem, op, id);
            op++;
            if (op > laz.length - 1) {
                op = 0;
            }
        }
    });
}

ROP.On("enter_suc", function () {
    ShowMsg("EnterSuc", "");
});
//重连中
ROP.On("reconnect", function () {
    ShowMsg("reconnect:");
});
//离线状态，之后会重连
ROP.On("offline", function (err) {
    ShowMsg("offline:" + err);
});
//登陆失败
ROP.On("enter_fail", function (err) {
    ShowMsg("EnterFail:" + err);
});
//收到消息
ROP.On("publish_data", function (data, topic) {
    ShowMsg(topic, data);
});
//彻底断线了
ROP.On("losed", function () {
    ShowMsg("Losed");
});

function ShowMsg (topic, data) {
    if (topic != "EnterSuc") {
        // "祝KOM22圆满成功！||ct0001||https://oss.eventnet.cn/tmp/testa.jpg"
        if (topic == "HLchat110192") {
            laz.splice(op + 1, 0, data.split('||')[1] + "||" + data.split('||')[2] + "||" + data.split('||')[3]);
        }
        if (topic == "hantingManage110192") {
            for (let i = 0; i < laz.length; i++) {
                let cid = laz[i].split("||")[1];
                if (cid == data.split('||')[1]) {
                    laz.splice(i, 1);
                    $("p[data-cid=" + cid + "]").css({ opacity: 0 });
                }
            }
        }
    } else {
    }
}

function OnEnter () {
    var num = Math.floor(Math.random() * (1 - 289207) + 289207);
    ROP.Enter(
        "pub_1135b7da2b6be95861dac60d08ad53a7",
        "sub_100d4e7886c50f6501cdc11bdf3a6e21",
        "suid_" + num,
        true
    );
}

function OnJoin () {
    ROP.Subscribe("HLchat110192");
    ROP.Subscribe("hantingManage110192");
}

OnEnter();
OnJoin();

document.body.addEventListener("touchstart", function () {
    //苹果
    //...空函数即可
});

function RDF (min, max) {
    return Math.floor(Math.random() * (max - min) + min);
}



// WEBPACK FOOTER //
// ./src/barrage.js